module.exports = __webpack_public_path__ + "src/assets/img/sg.eebb1f09.png";